module.exports = __webpack_public_path__ + "static/media/improving_residency.b954892a.webp";